module.exports = __webpack_public_path__ + "images/create-first-board/card-back/cardBack-tr.1baffc6274e721d9d532.svg";